const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export async function submitContactForm(payload) {
  const response = await fetch(`${API_BASE}/api/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const message =
      data?.error ||
      (data?.errors
        ? "Please complete the required fields."
        : "Unable to send your request right now. Please try again shortly.");
    const error = new Error(message);
    error.errors = data?.errors || null;
    error.status = response.status;
    throw error;
  }

  return data;
}
